import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CreateUserInvitationRequest, HttpResponse } from "@/types";

export function useCreateUserInvitation() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      createUserInvitationRequest,
    }: {
      createUserInvitationRequest: CreateUserInvitationRequest;
    }) => {
      const path = `companies/${currentCompanyId}/user-invitations`;
      const res = await httpClient.post<
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        void,
        HttpResponse<void>,
        CreateUserInvitationRequest
      >(path, createUserInvitationRequest);

      return res.data;
    },
  });

  return mutation;
}
